import React from 'react';
import { CompanyProvider } from './CompanyContext';
import { BaseUrlProvider } from './BaseUrlContext';


const Providers = ({ children }) => {
  return (
      <BaseUrlProvider>
        <CompanyProvider>
       {children}
        </CompanyProvider>
        </BaseUrlProvider>
    
  );
};

export default Providers;







// import React from 'react';
// import { AuthProvider } from './context/AuthContext';
// import { ThemeProvider } from './context/ThemeContext';
// import { CompanyProvider } from './context/CompanyContext';
// import { UserProvider } from './context/UserContext';

// const Providers = ({ children }) => {
//   return (
//     <AuthProvider>
//       <ThemeProvider>
//         <CompanyProvider>
//           <UserProvider>{children}</UserProvider>
//         </CompanyProvider>
//       </ThemeProvider>
//     </AuthProvider>
//   );
// };

// export default Providers;
